import * as React                                 from 'react'
import { Route, RouteComponentProps, withRouter } from 'react-router'

import {
  Process,
  Program,
  Programs,
} from '../components/environments'

const ProgramFromUrl = (
  { match: { params } }: RouteComponentProps<{ programId: number }>,
) => <Program {...params} />

const ProcessFromUrl = (
  { match: { params } }: RouteComponentProps<{ programId: number, processId: number }>,
) => <Process {...params} />

const ProgramRouting = ({ match }: RouteComponentProps<{}>) => (
  <>
    <Route
      exact
      path={`${match.path}`}
      component={Programs}
    />
    <Route
      exact
      path={`${match.path}/:programId`}
      component={ProgramFromUrl}
    />
    <Route
      exact
      path={`${match.path}/:programId/processes/:processId`}
      component={ProcessFromUrl}
    />
  </>
)

export default withRouter(ProgramRouting)



// WEBPACK FOOTER //
// ./src/routing/ProgramRouting.tsx